import React from 'react';
import PropTypes from 'prop-types';
import { Common } from 'ws-scripts/modules/common';

const invalidCharsRegex = /[^0-9]/g;

class PriceInput extends React.Component {
	render() {
		const { formattedValue, updateValue, placeholder, passedProps } =
			this.props;

		return (
			<Common
				render={({ labels }) => {
					return (
						<div className="form-group">
							<label
								htmlFor="pc-inputDownPayment"
								className="control-label"
							>
								{labels.get('DOWN_PAYMENT')}
								<input
									type="text"
									placeholder={placeholder}
									{...passedProps}
									value={formattedValue}
									onChange={(e) => {
										const val = e.target.value.replace(
											invalidCharsRegex,
											''
										);
										let newDP;
										if (val.length > 0) {
											newDP = Math.abs(parseInt(val, 10));
										} else {
											newDP = 0;
										}

										updateValue(newDP);
									}}
								/>
							</label>
						</div>
					);
				}}
			/>
		);
	}
}

PriceInput.propTypes = {
	value: PropTypes.number.isRequired,
	formattedValue: PropTypes.string.isRequired,
	updateValue: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	passedProps: PropTypes.shape({})
};

PriceInput.defaultProps = {
	placeholder: '',
	passedProps: {}
};

export default PriceInput;
